import { useRouter } from 'next/router'
import { useContext, useEffect, useState } from 'react'
import JobsResultsContainer from '../../components/JobsResultsContainer'
import AppContext from '../../context/AppContext'
import JobsSearchApi from '../../services/Jobs'
import {
	IFeaturedJobs,
	IJobItem,
	initParams,
	ISpecialJobs,
	Job
} from '../../services/Jobs/@type'
import { IJobSearch } from '../../services/models'
import { ELanguage, Toast } from '@microfrontends/react-components'

export default function FeaturedJobsContainer() {
	const { t, user, languageCode } = useContext(AppContext)
	const [jobsData, setJobsData] = useState<IJobSearch | null>(null)
	const [jobIds, setJobIds] = useState<number[] | null>(null)

	const router = useRouter()
	const { page } = router.query

	const searchJobs = async (ids: number[]) => {
		if (!ids || ids.length === 0) {
			setJobsData({
				...jobsData,
				data: []
			})
			return
		}
		try {
			const response = await JobsSearchApi.jobsSearch(
				{
					...initParams,
					page: Number(page ?? 0),
					hitsPerPage: 50,
					filter: [{ field: 'jobId', value: ids.toString() }]
				},
				languageCode || ELanguage.EN
			)
			if (response && response?.data) {
				let specialJobs: ISpecialJobs[] | null | undefined
				if (user && user?.accessToken) {
					specialJobs = await getSpecialJobsByIds(ids)
				}
				if (specialJobs) {
					const tempJobsData: IJobItem[] = []
					response?.data?.forEach((item) => {
						const findSpecialJobs = specialJobs?.find(
							(itemSpecial) => itemSpecial.id === item.jobId
						)
						tempJobsData.push(
							Object.assign({}, item, {
								isApplied: findSpecialJobs?.attributes.applied,
								isSaved: findSpecialJobs?.attributes.saved,
								isMatching: findSpecialJobs?.attributes.matching,
								jobInvitation: findSpecialJobs?.attributes?.jobInvitation ?? { jobInvitationId: 0, status: 0 }
							})
						)
					})
					setJobsData({
						...response,
						data: tempJobsData
					})
					return
				}
				setJobsData(response)
			}
		} catch (error) {
			console.error(error)
		}
	}
	const getFeaturedJobs = async () => {
		try {
			const response = await JobsSearchApi.featureJobs()
			if (response && response.data) {
				const featuredJobs: IFeaturedJobs[] = response.data
				let ids: number[] = []
				featuredJobs.forEach((item) => {
					if (item.id) {
						ids.push(item.id)
					}
				})
				if (ids) {
					setJobIds(ids)
				}
			}
		} catch (error) {
			console.error(error)
		}
	}

	const getSpecialJobsByIds = async (ids: number[]) => {
		try {
			if (user?.accessToken) {
				const data = await JobsSearchApi.specialJobs(
					ids,
					user.accessToken
				)
				if (data) {
					return data
				}
				return null
			}
		} catch (error) {
			console.error()
			return null
		}
	}
	useEffect(() => {
		getFeaturedJobs()
	}, [])
	useEffect(() => {
		if (jobIds) {
			searchJobs(jobIds)
		}
	}, [router.query, jobIds, user])

	return (
		<div>
			<JobsResultsContainer
				jobsData={jobsData}
				title={t('Featured Jobs')}
				description={t(
					'Thousands of good jobs with high salaries, friendly colleagues, and great benefits!'
				)}
			/>
			<Toast />
		</div>
	)
}
